import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext.tsx';
import saccoShareService from "@saccoShareService";

/**
 * Hook to record a SACCO share purchase and atomically debit the source account.
 * Calls create_sacco_share_with_debit RPC which handles currency conversion server-side.
 * On success: invalidates ['sacco_shares', membershipId] and ['transactions'] and ['accounts'].
 */
export function useCreateSaccoShareWithDebit() {
  const queryClient = useQueryClient();
  const { user } = useAuth();

  return useMutation({
    mutationFn: async (input: SaccoShareWithDebitRequest) => {
      if (!user) throw new Error('User not authenticated');
      return await saccoShareService.createShareWithDebit(user.id, input)
    },
    onSuccess: (_data, input) => {
      queryClient.invalidateQueries({ queryKey: ['sacco_shares', input.membershipId] });
      queryClient.invalidateQueries({ queryKey: ['transactions'] });
      queryClient.invalidateQueries({ queryKey: ['accounts'] });
    },
    onError: (error: Error) => {
      console.error('Sacco share purchase creation failed:', error);
    },
  });
}
